// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {LabelMediumText, LabelSmallText} from '../core/Type';
// Layouts
import {Grid} from '../layouts/Grid';
import OneColumnLayout from '../layouts/OneColumnLayout';
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';
import TabBar from '../controls/TabBar';
// Modules
import TopicHeader from '../modules/TopicHeader';
import UpsellCards from '../modules/UpsellCards';
import CircularTopicIcon from '../modules/CircularTopicIcon';
import SiteBar from '../modules/SiteBar';
import SiteFooter from '../modules/SiteFooter';


export default class HomePage extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            homepage: {
                display: "flex",
                flexDirection: "column-reverse",
                backgroundColor: CoreMetrics.Color.Neutral.OffWhite,
            },
            upsellCards: {
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
                paddingBottom: CoreMetrics.ElementSpacing.XLarge(),
            },
            tabBar: {
                height: CoreMetrics.ElementHeight.Medium(),
                marginLeft: 16,
            },
        });
        return (
            <div className={css(styles.homepage)}>
                <SiteFooter />

                <DomainList />

                <div className={css(styles.upsellCards)}>
                    <UpsellCards />
                </div>

                <OneColumnLayout
                    column1={<div
                        className={css(
                            styles.tabBar,
                            CoreStyles.hairlineStrokeBottom,
                        )}
                    >
                        <TabBar
                            items={[
                                "Explore",
                                "Classes",
                                "Practice",
                                "Mission",
                            ]}
                            selectedIndex={0}
                        />
                    </div>}
                />

                <TopicHeader />

                <SiteBar />
            </div>
        );
    }
}

class DomainList extends React.Component {
    render() {
        const emptyList = [null, null, null, null];
        return (
            <Grid>
                {emptyList.map((_, index) => <Domain key={`domain${index}`} />)}
            </Grid>
        );
    }
}

class Domain extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            domain: {
                paddingTop: CoreMetrics.ElementPadding.XLarge(),
                paddingBottom: CoreMetrics.ElementPadding.XLarge(),
            },
            topicIcon: {
                // This ensures that the grid does not expand this column for
                // the circular icon, which wants more space than we want to
                // give it.
                minWidth: 0,
            },
            course: {
                // This lets us add margin to the course.
                display: "inline-block",
                marginBottom: CoreMetrics.ElementPadding.Medium(),
            },
            coursePhone: {
                marginLeft: CoreMetrics.ElementSpacing.XLarge(),
            },
        });

        const courseNames = [
            "Early math",
            "Arithmetic",
            "Pre-algebra",
            "Algebra 1",
            "Geometry",
            "Algebra 2",
            "Trigonometry",
            "Precalculus",
            "Statistics & probability",
            "AP Calculus AB",
            "AP Calculus BC",
            "AP Statistics",
            "Multivariable calculus",
            "Differential equations",
            "Linear algebra",
        ];

        const sharedStyles = [styles.domain, CoreStyles.hairlineStrokeBottom];

        const tabletSideSpace = <CssGridSpace size={0} sizeTablet={2} />;

        return <CssGrid styles={[...sharedStyles]}>
            <CssGridRow>
                {tabletSideSpace}

                <CssGridColumn size={1} styles={[styles.topicIcon]}>
                    <CircularTopicIcon />
                </CssGridColumn>

                <CssGridColumn size={3} sizeTablet={7}>
                    <LabelMediumText>
                        Transformations
                    </LabelMediumText>
                    <LabelSmallText>
                        12 of 38 complete
                    </LabelSmallText>
                    <LabelMediumText>
                        In this topic you will learn about the most useful math
                        concept for creating video game graphics: geometric
                        transformations, specifically translations, rotations,
                        reflections, and dilations. You will learn how to
                        perform the transformations, and how to map one figure
                        into another using these transformations.
                    </LabelMediumText>
                </CssGridColumn>

                <CssGridColumn size={0} sizeDesktop={6}>
                    <CssGrid size={6} columnsWithin={2}>
                        <CssGridRow>
                            {courseNames.map((courseName, index) =>
                                <CssGridColumn
                                    key={`courseMobile${index}`}
                                    size={0}
                                    sizeDesktop={3}
                                >
                                    <LabelSmallText styles={[styles.course]}>
                                        {courseName}
                                    </LabelSmallText>
                                </CssGridColumn>
                            )}
                        </CssGridRow>
                    </CssGrid>
                </CssGridColumn>

                <CssGridColumn size={0} sizeDesktop={2}>
                    <LabelSmallText>
                        24% Unit Mastery
                    </LabelSmallText>
                </CssGridColumn>

                {tabletSideSpace}
            </CssGridRow>
        </CssGrid>;
    }
}



// WEBPACK FOOTER //
// ./src/demo/SubjectPage.jsx